export default __webpack_public_path__ + "static/media/SST.79e0ccc6.webp";